import React, { useState, useContext, useEffect } from 'react';
import Highcharts from 'highcharts'
import axios from 'axios';
import HighchartsReact from 'highcharts-react-official'
import UserContext  from '../../context/Globales/UserContext';


const Grafico2Modal =()=> {

// FUNCION PARA CONVERTIR GRAFICO EN IMAGEN;
const [stategrafiModal, setStateModal] = React.useState();

const pdfgrafico2 =()=>{
	///let link = "data:image/svg+xml;base64," + btoa(this.lineChartRef.current.CHART.current.chart.getSVG());

    const chartoptionss = JSON.stringify(options)
	localStorage.removeItem("imgPdfGrafiModal");

//Create a data body with the following parameters 
    let DataGraficoModal = {
      options: chartoptionss,
      filename: 'LineChart',
      async: true
    }

    let url = "https://export.highcharts.com/"
    let returnedimageurl2 = ""
    //setState will be called within the Axios return so "This" must 
    let self = this

    axios({
     method: 'post',
     url: 'https://export.highcharts.com/',
     data: DataGraficoModal,
    })
    .then(function (response) {
      returnedimageurl2= url +response.data;

	  let RutaImg2 = returnedimageurl2.replace('data:image/svg+xml;base64,', '');
		//console.log(RutaImg2);
	  localStorage.setItem("imgPdfGrafiModal", JSON.stringify(RutaImg2));

	  
	//	console.log('RutaImg',RutaImg);
	setStateModal({
        activityChartPng: url
      },) //self.allowDownload())

		// console.log(returnedimageurl);
    })
    .catch(function (response) {
        //handle error
     // console.log(response);
    }); 

}

const  { datoICMODAL }= useContext(UserContext);


useEffect(() => {
	pdfgrafico2();
}, []);



			let Data1 = parseInt(datoICMODAL.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.MasDe24Meses.Montos.split(".").join("")) / 1000;
			let Data2 = parseInt(datoICMODAL.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.De12a24Meses.Montos.split(".").join("")) / 1000;
			let Data3 = parseInt(datoICMODAL.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.De6a12Meses.Montos.split(".").join("")) / 1000;
			let Data4 = parseInt(datoICMODAL.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.Ultimos6Meses.Montos.split(".").join("")) / 1000;
			let contai;
			
			const options = {
				chart: {
					renderTo: contai,
					zoomType: 'xy'
				},
				title: {
					text: ''
				},
				credits: {
					text: 'pch.cl',
					href: false,
				},
				exporting: {
							  enabled: false
							},
				subtitle: {
					text: ''
				},
				xAxis: [{
					categories: [' ','Mas de 24 Meses', '12 a 24 Meses', '6 a 12 Meses', 'Ultimos 6 Meses'],
					crosshair: true
				}],
				yAxis: [{ // Primary yAxis
					labels: {
						format: '{value} Cant.',
						style: {
							color: 'black'
						}
					},
					title: {
						text: 'Cant. Doctos Acumulados',
						style: {
							color: 'black'
						}
					},
					opposite: true

				}, { // Secondary yAxis
					gridLineWidth: 0,
					title: {
						text: 'Montos en Miles Ingresados',
						style: {
							color: Highcharts.getOptions().colors[0]
						}
					},
					labels: {
						format: '{value} M',
						style: {
							color: Highcharts.getOptions().colors[0]
						}
					}

				}],
				tooltip: {
					shared: true
				},
				legend: {
					layout: 'vertical',
					align: 'left',
					x: 80,
					verticalAlign: 'top',
					y: 55,
					floating: true,
					backgrocontainer1undColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
				},
				series: [{
					name: 'Montos en Miles Ingresados',
					type: 'spline',
					yAxis: 1,
					data: [0,parseInt(Data1), parseInt(Data2), parseInt(Data3), parseInt(Data4)],
					tooltip: {
						valueSuffix: ''
					}

				}, {
					name: 'Cant. Doctos Acumulados',
					type: 'spline',
					data: [0,parseInt(datoICMODAL.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.MasDe24Meses.AcumuladoDocumentos), parseInt(datoICMODAL.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.De12a24Meses.AcumuladoDocumentos), parseInt(datoICMODAL.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.De6a12Meses.AcumuladoDocumentos), parseInt(datoICMODAL.DetallesMorosidadesYProtestos?.DistribucionPeriodosAcumulados?.Ultimos6Meses.AcumuladoDocumentos)],
					tooltip: {
						valueSuffix: ''
					}
				}]
			};
	const plugins = [
		{
			afterDraw: (chartInstance, easing) => {
				const { ctx } = chartInstance.chart;
				//ctx.fillText('This text drawn by a plugin', 300, 300);
			}
		}
	];


		return (
            <>
        
			<HighchartsReact
        	highcharts={Highcharts}
        	options={options}
      />
	
            </>
		);

}

export default Grafico2Modal;